// removed by extract-text-webpack-plugin
module.exports = {"propertiesCounter":"_3MHVC2TpDScuNDVuIo9tBB","actionText":"_3vxlQ4KZdanEIqrWC6xnaK"};


//////////////////
// WEBPACK FOOTER
// ./src/components/PropertiesCounter/PropertiesCounter.scss
// module id = 1697
// module chunks = 0